const mode = import.meta.env.MODE;

const baseChildren = [
  {
    path: 'gift-list',
    name: 'giftList',
    component: () => import('@/views/gift/list/index.vue'),
    meta: {
      locale: '礼物列表',
      requiresAuth: true,
      roles: ['super', 'admin', 'service', 'special_service'],
    },
  },
  {
    path: 'blacklist',
    name: 'blacklist',
    component: () => import('@/views/blacklist/list/index.vue'),
    meta: {
      locale: '黑名单管理',
      requiresAuth: true,
      roles: ['super', 'admin', 'service', 'special_service'],
    },
  },
];

const extraChildren = [
  {
    path: 'points-aquarium-list',
    name: 'points-aquariumList',
    component: () => import('@/views/points-aquarium/list/index.vue'),
    meta: {
      locale: '水族馆列表',
      requiresAuth: true,
      roles: ['super', 'admin', 'service', 'special_service'],
    },
  },
  {
    path: 'cdkey-list',
    name: 'cdkeyList',
    component: () => import('@/views/cdkey/list/index.vue'),
    meta: {
      locale: '序列号列表',
      requiresAuth: true,
      roles: ['super', 'admin'],
    },
  },
  {
    path: 'bind-list',
    name: 'bind-list',
    component: () => import('@/views/bind/list/index.vue'),
    meta: {
      locale: '游戏账号绑定',
      requiresAuth: true,
      roles: ['super', 'admin', 'service', 'special_service'],
    },
  },
];

export default {
  path: 'operations',
  name: 'operations',
  component: () => import('@/views/gift/index.vue'),
  meta: {
    locale: '运营管理',
    requiresAuth: true,
    icon: 'icon-apps',
  },
  children: [
    ...baseChildren,
    ...(mode !== 'pro_party' ? extraChildren : []),
  ],
};
